import type { LabelHTMLAttributes, ReactNode } from 'react';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
}

export const Label = ({ children, className = '', ...rest }: LabelProps) => (
  <label
    className={[
      'block text-xs uppercase tracking-wider text-zinc-500 mb-1.5',
      className,
    ].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </label>
);
